import { Injectable } from '@angular/core';

declare var $:any;

@Injectable()
export class NotifyService {

  constructor() { }

  show(message, type = 'info', icon = 'fa fa-info-circle', title = '', url = '') {
    $.notify({
      title: title,
      message: message,
      icon: icon,
      url: url
    },{
      allow_dismiss: false,
      showProgressbar: false,
      type: type,
      placement: {
				from: "top",
				align: "right"
			}
    });
  }

}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/addon/notify.service.ts